module.exports = __webpack_public_path__ + "static/panama-2-a027f3641819545f4ab1b9421c9f3f94.jpg";